import React, { useEffect } from 'react';
import { RPCFactory } from '../../../utils/RequestUtil';
import useList from '../../hooks/useList';
import { Column, Dialog, Table } from '@tencent/spaui';

import useDialog from '../../../leads_component/shared-components/hooks/useDialog';

const Page = (props) => {
  const recordListHooks = useList({ data: [] });
  const detailDialog = useDialog({ showDialog: false });

  useEffect(() => {
    RPCFactory.leadsManage
      .getLeadsPushRecordInfo(props.leadsId)
      .done((data) => {
        recordListHooks.setDataList(data.entities);
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  }, []);

  const renderStatus = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value == 1) {
      return '推送失败';
    }
    if (value == 2) {
      return '推送成功';
    }
    return value;
  };

  const renderOperate = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    return (
      <a
        href="javascript:void(0)"
        onClick={(e) => {
          detailDialog.showAsEditModel(data);
        }}
      >
        查看详情
      </a>
    );
  };

  return (
    <div className="follow-calling">
      <div className="datalist">
        <Table data={recordListHooks.dataList}>
          <Column name="pushTime">推送时间</Column>
          <Column name="leadsPushUrl">推送地址</Column>
          <Column name="status" render={renderStatus}>
            推送状态
          </Column>
          <Column name="operate" render={renderOperate}>
            操作
          </Column>
        </Table>
      </div>
      {detailDialog.showDialog ? (
        <Dialog
          {...detailDialog.props}
          title="线索推送详情"
          // className="modal-max-height"
          style={{ width: '600px' }}
          bodyStyle={{
            'max-height': 'min(500px,calc(100vh - 255px))',
            'overflow-y': 'auto',
          }}
          hideFooter
        >
          <div className="apiconfig-des">
            <div className="form-list-normal form-list-read">
              <div className="lump">
                <div className="lump-bd">
                  <ul className="infos">
                    <li className="infolist">
                      <span className="info-tt">推送时间</span>
                      <div className="info-des">
                        <p className="read-des">{detailDialog.contentProps.data.pushTime}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">推送地址</span>
                      <div className="info-des">
                        <p className="read-des">{detailDialog.contentProps.data.leadsPushUrl}</p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">推送状态</span>
                      <div className="info-des">
                        <p className="read-des">
                          {detailDialog.contentProps.data.status == 1 ? '推送失败' : '推送成功'}
                        </p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">推送请求内容</span>
                      <div className="info-des">
                        <p
                          className="read-des"
                          style={{ 'white-space': 'pre-wrap', 'word-wrap': 'break-word', 'word-break': 'break-all' }}
                        >
                          {detailDialog.contentProps.data.pushRequest}
                        </p>
                      </div>
                    </li>
                    <li className="infolist">
                      <span className="info-tt">推送响应内容</span>
                      <div className="info-des">
                        <p
                          className="read-des"
                          style={{ 'white-space': 'pre-wrap', 'word-wrap': 'break-word', 'word-break': 'break-all' }}
                        >
                          {detailDialog.contentProps.data.pushResponse}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      ) : null}
    </div>
  );
};

export default Page;
